module.exports = __webpack_public_path__ + "static/media/skeleton.e6fb2f97.png";